<div class="header">
    <breadcrumbs class="header__heading"></breadcrumbs>
    <ntf-notification-header></ntf-notification-header>
    <personal-panel class="header__personal-panel"></personal-panel>
</div>
